import { Textarea } from '~/components/ui/textarea'
import { useFieldContext } from '~/hooks/form-hooks'
import { Field, fieldErrorMessage, type FieldProps } from './field'

type TextareaFieldProps = Omit<
  React.ComponentProps<typeof Textarea>,
  'value' | 'onChange' | 'onBlur' | 'name'
> &
  Pick<FieldProps, 'label' | 'optional' | 'labelClassName' | 'labelTextClassName'> & {
    /** Classe du conteneur (libellé + zone + erreur) ; `className` va à la zone de texte. */
    fieldClassName?: string
  }

/**
 * Zone de texte multiligne branchée sur TanStack Form : libellé au-dessus, premier message
 * d'erreur du schéma en dessous. Style de la primitive `Textarea`, surchargeable par `className`.
 */
export function TextareaField({
  label,
  id,
  optional,
  labelClassName,
  labelTextClassName,
  fieldClassName,
  ...props
}: TextareaFieldProps) {
  const field = useFieldContext<string>()
  const error = fieldErrorMessage(field.state.meta.errors)
  const inputId = id ?? field.name

  return (
    <Field
      label={label}
      id={inputId}
      optional={optional}
      required={props.required}
      error={error}
      className={fieldClassName}
      labelClassName={labelClassName}
      labelTextClassName={labelTextClassName}
    >
      <Textarea
        {...props}
        id={inputId}
        name={field.name}
        value={field.state.value}
        onBlur={field.handleBlur}
        onChange={(event) => field.handleChange(event.target.value)}
        aria-invalid={error !== undefined}
      />
    </Field>
  )
}
